<template>
  <div>
    <v-bottom-navigation background-color="blue-grey darken-4" dark fixed grow height="70" mandatory>
      <v-btn :to="`/${$store.state.merchant.slug}/products/whatsapp`">
        <span>Whatsapp</span>
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn :to="`/${this.$store.state.merchant.slug}/products/instagram`">
        <span>Instagram</span>
        <v-icon>mdi-instagram</v-icon>
      </v-btn>
      <v-btn>
        <span>Jiji</span>
        <v-icon>mdi-cart</v-icon>
      </v-btn>
      <v-btn @click="showView('more')">
        <span>More</span>
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-bottom-sheet inset max-width="500" v-model="views.more">
      <MoreAddProductOptions @close="closeViews()" @view="showView($event)"/>
    </v-bottom-sheet>
  </div>
</template>

<script>
import views from "@/mixins/views";
import MoreAddProductOptions from "@/components/standalone/merchants/MoreAddProductOptions";

export default {
  name: "AddProductOptionsBottomNav",
  components: { MoreAddProductOptions },
  mixins: [views],
  data() {
    return {
      views: {
        more: false
      }
    }
  }
}
</script>
